import { connect } from 'react-redux';

import { getUpdatingFunnel } from '../../../reducers/analyticsApp';
import { setFunnelName } from '../../../actions/funnel';
import CompoundUpdateName from '../../../components/compound/update/Name';

const mapStateToProps = (state) => ({
  name: getUpdatingFunnel(state).name,
});

const mapDispatchToProps = {
  onChange: setFunnelName,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateName);
